var data = {
  mnCheck:{name:'', dt:'yyyymm'}
};

var mutations = {
  'SET_MN_CHECK'(state, mnCheck) {
    state.mnCheck = mnCheck;
    // var idx = -1;
    // for(var i=0;i<state.mnCheck.length;i++) {
    //   var item = state.medal[i];
    //   if(medal.name == item.name && medal.type == item.type) {
    //     idx = i;
    //   }
    // }
    // if(idx != -1) {
    //   console.log('store.js medal.js idx', idx);
    //   state.medal.splice(idx, 1);
    // }

    // state.medal.push(medal);
  }
};

var getters = {
  mnCheck: state => state.mnCheck
};

export default {
  state: data,
  getters,
  // actions,
  mutations
}
